import { useCallback, useContext, useState } from 'react';
import Select from "react-select";
import 'react-toastify/dist/ReactToastify.css';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { bankList, currentDateAndTime } from '../../Constants/constants';
import React from 'react';
import { SubmitButton } from '../../Components/InputElements';

const bankAccountType = [
  { value: "Current Account", label: "Current Account" },
  { value: "Saving Account", label: "Saving Account" },
  { value: "Fixed Deposit Account", label: "Fixed Deposit Account" },
  { value: "Recurring Deposit Account", label: "Recurring Deposit Account" },
  { value: "NRI Account", label: "NRI Account" },
];

const BankCreate = React.memo((props) => {
    const { apiURL, apiHeaderJSON } = useContext(ConfigContext);

    const [formData, setFormData] = useState({
        bank_name: props.data?.bank_name || "",
        account_holder_name: props.data?.account_holder_name || "",
        branch_name: props.data?.branch_name || "",
        account_number: props.data?.account_number || "",
        ifsc_code: props.data?.ifsc_code || "",
        account_type: props.data?.account_type || "",
    });
    const [errors, setErrors] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }
    const handleIFSCChange = (e) => {
        const {name, value} = e.target;
        if (value?.length >= 4){
            setFormData({ ...formData, [name]: value });
        }
        setErrors({ ...errors, [name]: "" });
    }

    const validateForm = () => {
        let errors = {}

        if (!formData?.bank_name) {
            errors.bank_name = "Bank name is required!"
            return errors;
        }
        if (!formData?.account_holder_name) {
            errors.account_holder_name = "This field is required!"
            return errors;
        }
        if (!formData?.branch_name) {
            errors.branch_name = "Branch name is required!"
            return errors;
        }
        if (!formData?.account_number) {
            errors.account_number = "Account no. is required!"
            return errors;
        }
        if (!formData?.ifsc_code) {
            errors.ifsc_code = "IFSC code is required!"
            return errors;
        }
        if (formData?.account_number && formData?.ifsc_code && (formData?.account_number === formData?.ifsc_code)) {
            errors.ifsc_code = "IFSC code cannot be same as Account number!"
            return errors;
        }
        if (!formData?.account_type) {
            errors.account_type = "This field is required!"
            return errors;
        }

        return errors
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        if(loadingPost) return;
        setLoadingPost(true);
        const headers = apiHeaderJSON;

        const errors = validateForm();
        // console.log("errors 1", errors);
        if (Object.keys(errors)?.length > 0) {
            setErrors(errors);
            setLoadingPost(false);
            return;
        }

        const data = {
            company_bank_id: props.data?.company_bank_id || null,
            bank_name: formData?.bank_name || "",
            account_holder_name: formData?.account_holder_name || "",
            branch_name: formData?.branch_name || "",
            account_number: formData?.account_number || "",
            ifsc_code: formData?.ifsc_code || "",
            account_type: formData?.account_type || "",
            date: currentDateAndTime(),
        }

        // console.log("handleSubmit ~ Data =======>>>", data);
        
        axios.post(`${apiURL}Masters/CreateUpdateCompanyBank`, data, {headers,})
            .then((response) => {
                const { success } = response.data;
                // console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {
                    // setFilterData({ company_id: "", location_id: "", })
                    setFormData({ ...formData,  bank_name: "", account_holder_name: "", branch_name: "", account_number: "", ifsc_code: "", account_type: "",});
                    handleClose();
                }
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                });
                setLoadingPost(false);
            })
            .catch((error)=>{
                setLoadingPost(false);
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
    }

    // console.log("filterData?.company_id, filterData?.location_id",filterData?.company_id, filterData?.location_id);

    const handleBankSelect = useCallback((selectedOption)=>{
        setFormData({ ...formData, bank_name: selectedOption?.value, ifsc_code: selectedOption?.code }); 
        setErrors({ ...errors, bank_name:"", ifsc_code: "" });
    },[formData, errors]);  

    const handleBankAccountSelect = useCallback((selectedOption)=>{
        setFormData({ ...formData, account_type: selectedOption?.value,}); 
        setErrors({ ...errors, account_type:"" });
    },[formData, errors]);  

    const handleClose = (event) => {
        if (props.onClick) {
        props.handleClose(event);
        }
    };
    const handleCloseModal = (event) => {
        if (props.onClick) {
        props.onClick(event);
        }
    };

    // if (loadingPost) return <MainPageLoader/>;

    return (
        <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
            <div className="m-auto mt-3 w-modal">
            <div className="modal-content">
                <div className="modal-header pb-0">
                    <h5 className="modal-title" id="myModalLabel">{formData?.machine_id ? "Update" : "Create"} Bank</h5>
                    <button onClick={handleCloseModal} disabled={loadingPost} className="btn-close" aria-label="Close"/>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit} 
                            className="row">
                                <div className={`col-md-6 ${errors.bank_name ? "" : "mb-5"}`}>
                                    <label className="form-label" >Select Company</label>
                                    <div className=' position-absolute z-2 w-100 pe-3' >
                                        <Select onChange={handleBankSelect}
                                        placeholder={`Select Bank`}
                                        options={bankList}
                                        value={formData?.bank_name ? bankList.find(option => option.value === formData?.bank_name) : null}
                                        />
                                    </div>
                                    {errors.bank_name && <div className="text-danger mt-5">{errors.bank_name}</div>}
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label htmlFor="account_holder_name" className="form-label">Account Holder Name</label>
                                    <input onChange={handleChange}
                                    type="text" id="account_holder_name" name="account_holder_name"
                                    placeholder="Enter Name"
                                    className={`form-control ${errors.account_holder_name ? 'is-invalid' : ''}`}
                                    value={formData?.account_holder_name}
                                    />
                                    {errors.account_holder_name && <div className="text-danger">{errors.account_holder_name}</div>}
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label htmlFor="branch_name" className="form-label">Branch Name</label>
                                    <input onChange={handleChange}
                                    type="text" id="branch_name" name="branch_name"
                                    placeholder="Enter Branch Name"
                                    className={`form-control ${errors.branch_name ? 'is-invalid' : ''}`}
                                    value={formData?.branch_name}
                                    />
                                    {errors.branch_name && <div className="text-danger">{errors.branch_name}</div>}
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label htmlFor="account_number" className="form-label">Account Number</label>
                                    <input onChange={handleChange} 
                                        type="text"
                                        id="account_number" name="account_number"
                                        className={`form-control ${errors.account_number ? 'is-invalid' : ''}`}
                                        value={formData?.account_number}
                                        placeholder="Enter Number"
                                    />
                                    {errors.account_number && <div className="text-danger">{errors.account_number}</div>}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="ifsc_code" className="form-label">IFSC Code</label>
                                    <input onChange={handleIFSCChange}
                                    id="ifsc_code" name="ifsc_code"
                                    type="text" placeholder="Enter Code"
                                    className={`form-control ${errors.ifsc_code ? 'is-invalid' : ''}`}
                                    value={formData?.ifsc_code}
                                    />
                                    {errors.ifsc_code && <div className="text-danger">{errors.ifsc_code}</div>}
                                </div>
                                <div className={`col-md-6 ${errors.account_type ? "" : "mb-5"}`}>
                                    <label className="form-label" >Account Type</label>
                                    <div className=' position-absolute z-2 w-100 pe-3' >
                                        <Select onChange={handleBankAccountSelect}
                                        placeholder={`Select Account Type`}
                                        options={bankAccountType}
                                        value={formData?.account_type ? bankAccountType.find(option => option.value === formData?.account_type) : null}
                                        />
                                    </div>
                                    {errors.account_type && <div className="text-danger mt-5">{errors.account_type}</div>}
                                </div>
                                <div className="col-md-12">
                                    <SubmitButton loading={loadingPost} loadingMessage='Loading' 
                                    buttonName={"Save"} icon={'ri-save-line'} 
                                    type='primary' iconSide='left' />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
})

export default BankCreate;
